<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-primary text-white" inline-actions>
        <div>
          بررسی وضعیت بالانس حساب راننده
        </div>
      </q-banner>
    </q-card-section>
    <q-card-section class="text-center">
      <q-chip square clickable @click="loadBalanceInfo(item)" icon="person" v-for="(item, index) in driversList"
              :key="index"
              :label="item.UserName"/>
    </q-card-section>
    <q-card-section class="text-center">
      <div class="row justify-center" v-if="selectedDriver">
        <div class="col-xs-12 col-md-3">
          {{ selectedDriver.UserName }}
        </div>
      </div>
      <div class="row justify-center" v-if="selectedDriver">
        <div class="col-xs-12 col-md-3">
          <q-input v-model="filter" filled label="جستجو ..."/>
          <q-table
              selection="single"
              :data="lodash.orderBy(balanceItems, item=> item.WayBillNumber, 'desc')"
              row-key="WayBillNumber"
              wrap-cells
              :hide-header="$q.screen.lt.md"
              flat
              :filter="filter"
              :rows-per-page-options=[100]>
            <template v-slot:header>
              <q-tr class="text-center text-bold">
                <td>شماره بارنامه</td>
                <td>سند هزینه</td>
                <td>سند پرداخت</td>
                <td>وضعیت</td>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr :props="props" class="text-center">
                <td>
                  <q-chip @click="loadInfo(props.row)" :label="props.row.WayBillNumber" square clickable/>
                </td>
                <td class="text-red text-bold">
                  {{ props.row.Debit.toLocaleString() }}
                </td>
                <td class="text-green text-bold">
                  {{ props.row.Credit.toLocaleString() }}
                </td>
                <td :class="props.row.Credit?'text-green text-bold':'text-red text-bold'">
                  {{ props.row.Credit ? 'پرداخت شده' : 'پرداخت نشده' }}
                </td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </div>
    </q-card-section>
    <q-dialog persistent v-model="itemInfoDialog" :full-width="$q.screen.lt.md">
      <WayBillInfoItem :item="selectedItem"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import WayBillInfoItem from "@/components/Driver/WayBillInfoItem.vue";

export default {
  name: "GetWayBillBalanceInfo",
  components: {WayBillInfoItem},
  props: {},
  data() {
    return {
      filter: undefined,
      driversList: [],
      selectedItem: undefined,
      selectedWayBillInfo: undefined,
      balanceItems: [],
      itemInfoDialog: false,
      selectedDriver: undefined,
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
    }
  },
  methods: {
    ...mapActions({
      getDriversList: 'Users/getDriversList',
      getDriversBalanceInfo: 'Drivers/getWayBillBalance',
      getWayBillInfo: 'Drivers/getWayBillInfo'
    }),
    loadInfo(wayBillInfo) {
      this.getWayBillInfo(wayBillInfo.WayBillNumber).then((res) => {
        this.selectedItem = res.data[0]
        this.itemInfoDialog = true
      })
    },
    loadBalanceInfo(userInfo) {
      this.balanceItems = []
      this.selectedDriver = userInfo
      this.getDriversBalanceInfo(userInfo.MohasebanID).then((res) => {
        this.balanceItems = res.data
      })
    }
  },
  created() {
    this.getDriversList().then((res) => {
      if (this.$store.state.roles.some(v => ['user_driver'].includes(v))) {
        this.driversList = res.filter(item => item.Users_ID === parseInt(this.$store.state.userId))
      } else {
        this.driversList = res
      }
    })
  }
}
</script>

<style scoped>

</style>